// Faculty data with full names and codes
const faculties = [
  {
    code: 'EMS',
    name: 'Economic and Management Sciences',
    icon: 'account_balance',
    color: '#0068A2',
    gradient: 'linear-gradient(90deg, #0068A2 0%, #0096D6 100%)',
    description: 'Faculty of Economic and Management Sciences'
  },
  {
    code: 'EDU',
    name: 'Education',
    icon: 'school',
    color: '#FAAF18',
    gradient: 'linear-gradient(90deg, #FAAF18 0%, #FFD966 100%)',
    description: 'Faculty of Education'
  },
  {
    code: 'EBIT',
    name: 'Engineering, Built Environment and IT',
    icon: 'engineering',
    color: '#007A7C',
    gradient: 'linear-gradient(90deg, #007A7C 0%, #00B3B5 100%)',
    description: 'Faculty of Engineering, Built Environment and Information Technology'
  },
  {
    code: 'MED',
    name: 'Health Sciences',
    icon: 'medical_services',
    color: '#4D87C6',
    gradient: 'linear-gradient(90deg, #4D87C6 0%, #7FB3E6 100%)',
    description: 'Faculty of Health Sciences'
  },
  {
    code: 'HUM',
    name: 'Humanities',
    icon: 'psychology',
    color: '#DB5C1C',
    gradient: 'linear-gradient(90deg, #DB5C1C 0%, #FF8C42 100%)',
    description: 'Faculty of Humanities'
  },
  {
    code: 'LAW',
    name: 'Law',
    icon: 'gavel',
    color: '#A90A31',
    gradient: 'linear-gradient(90deg, #A90A31 0%, #E03A5E 100%)',
    description: 'Faculty of Law'
  },
  {
    code: 'SCI',
    name: 'Natural and Agricultural Sciences',
    icon: 'science',
    color: '#6C9E2F',
    gradient: 'linear-gradient(90deg, #6C9E2F 0%, #A3D977 100%)',
    description: 'Faculty of Natural and Agricultural Sciences'
  },
  {
    code: 'THEO',
    name: 'Theology and Religion',
    icon: 'auto_stories',
    color: '#800051',
    gradient: 'linear-gradient(90deg, #800051 0%, #C94F9B 100%)',
    description: 'Faculty of Theology and Religion'
  },
  {
    code: 'VET',
    name: 'Veterinary Science',
    icon: 'pets',
    color: '#891B35',
    gradient: 'linear-gradient(90deg, #891B35 0%, #D94F6A 100%)',
    description: 'Faculty of Veterinary Science'
  },
  {
    code: 'GIBS',
    name: 'Gordon Institute of Business Science',
    icon: 'business_center',
    color: '#4338ca', // fallback, unknown real color
    gradient: 'linear-gradient(90deg, #4338ca 0%, #6366f1 100%)',
    description: 'Gordon Institute of Business Science'
  }
];

// Student Services & Important Contacts
const studentServices = [
  {
    id: 'ssc',
    title: 'Student Service Centre',
    icon: 'support_agent',
    color: '#0068A2',
    contacts: [
      {
        type: 'phone',
        label: 'Main Line',
        value: '+27 (0)12 420 3111',
        icon: 'call',
        link: 'tel:+27124203111'
      },
      {
        type: 'email',
        label: 'Email',
        value: 'ssc@up.ac.za',
        icon: 'email',
        link: 'mailto:ssc@up.ac.za'
      }
    ]
  },
  {
    id: 'crisis',
    title: 'Crisis & Emergency',
    icon: 'emergency',
    color: '#A90A31',
    contacts: [
      {
        type: 'phone',
        label: 'Crisis Line (Toll-Free)',
        value: '+27 (0)80 000 6428',
        icon: 'crisis_alert',
        link: 'tel:+27800006428',
        priority: true
      },
      {
        type: 'phone',
        label: '24-Hour Operations Centre',
        value: '+27 (0)12 420 2310/2760',
        icon: 'shield',
        link: 'tel:+27124202310'
      },
      {
        type: 'phone',
        label: '24-Hour Operations Manager',
        value: '+27 (0)83 654 0476',
        icon: 'contact_phone',
        link: 'tel:+27836540476'
      }
    ]
  },
  {
    id: 'online',
    title: 'Online Services',
    icon: 'language',
    color: '#6C9E2F',
    contacts: [
      {
        type: 'link',
        label: 'Virtual Campus',
        value: 'virtualcampus.up.ac.za',
        icon: 'school',
        link: 'https://virtualcampus.up.ac.za'
      },
      {
        type: 'link',
        label: "Parents' Portal",
        value: 'up.ac.za/parents',
        icon: 'family_restroom',
        link: 'https://www.up.ac.za/parents'
      },
      {
        type: 'link',
        label: 'Student Finance',
        value: 'Fees & Funding Info',
        icon: 'payments',
        link: 'https://www.up.ac.za/article/2749200/fees-and-funding'
      }
    ]
  }
];

// Campus Locations with Google Maps
const campusLocations = [
  {
    name: 'Hatfield Campus',
    icon: 'location_city',
    color: '#0068A2',
    mapLink: 'https://maps.app.goo.gl/C6kXAz8MT9gsNjA8A',
    description: 'Main campus located in Hatfield, Pretoria'
  },
  {
    name: 'Hillcrest Campus',
    icon: 'apartment',
    color: '#4D87C6',
    mapLink: 'https://maps.app.goo.gl/DzqBBXFvsnDeHWJ2A',
    description: 'Campus in Hillcrest'
  },
  {
    name: 'Groenkloof Campus',
    icon: 'school',
    color: '#FAAF18',
    mapLink: 'https://maps.app.goo.gl/b6WJh3fKfyPyN68h8',
    description: 'Faculty of Education campus'
  },
  {
    name: 'Prinshof Campus',
    icon: 'medical_services',
    color: '#4D87C6',
    mapLink: 'https://maps.app.goo.gl/MM8jw96fUCvZwE9r9',
    description: 'Faculty of Health Sciences campus'
  },
  {
    name: 'Onderstepoort Campus',
    icon: 'pets',
    color: '#891B35',
    mapLink: 'https://maps.app.goo.gl/u31W6Ud1TKjwCw4k6',
    description: 'Faculty of Veterinary Science campus'
  },
  {
    name: 'Mamelodi Campus',
    icon: 'domain',
    color: '#6C9E2F',
    mapLink: 'https://maps.app.goo.gl/YYxUoqbuDPpgjLrx9',
    description: 'Campus in Mamelodi'
  },
  {
    name: 'Gordon Institute of Business Science (GIBS)',
    icon: 'business_center',
    color: '#4338ca',
    mapLink: 'https://maps.app.goo.gl/3Nws2L9dhvwPrp6Y7',
    description: 'Business school campus in Illovo, Johannesburg'
  }
];

export function useResources() {
  const currentYear = new Date().getFullYear();

  // Generate yearbook URL for a faculty
  const getYearbookUrl = (facultyCode, year = currentYear, fullContent = true) => {
    const contentParam = fullContent ? '?content=full' : '';
    return `https://www.up.ac.za/yearbooks/${year}/pdf/faculty/${facultyCode}${contentParam}`;
  };

  // Get yearbooks for all faculties
  const getYearbooks = (year = currentYear) => {
    return faculties.map(faculty => ({
      ...faculty,
      summaryUrl: getYearbookUrl(faculty.code, year, false),
      fullUrl: getYearbookUrl(faculty.code, year, true),
      year: year,
      type: 'yearbook',
      title: `${faculty.name} Yearbook ${year}`
    }));
  };

  // Sort yearbooks with user's faculty first
  const sortYearbooksByUserFaculty = (yearbooks, userFaculty) => {
    if (!userFaculty) return yearbooks;

    // Find matching faculty
    const matchedFaculty = faculties.find(f => 
      f.name.toLowerCase().includes(userFaculty.toLowerCase()) ||
      f.code.toLowerCase() === userFaculty.toLowerCase()
    );

    if (!matchedFaculty) return yearbooks;

    // Sort: matched faculty first, then others
    return [...yearbooks].sort((a, b) => {
      if (a.code === matchedFaculty.code) return -1;
      if (b.code === matchedFaculty.code) return 1;
      return 0;
    });
  };

  // Get all resources
  const getStudentServices = () => {
    return studentServices;
  };

  const getCampusLocations = () => {
    return campusLocations;
  };

  // Track recently accessed resources
  const getRecentResources = () => {
    try {
      return JSON.parse(sessionStorage.getItem('recentResources') || '[]');
    } catch (e) {
      return [];
    }
  };

  const trackResourceAccess = (resource) => {
    try {
      let recent = getRecentResources();
      // Remove if already exists
      recent = recent.filter(r => r.link !== resource.link && r.fullUrl !== resource.fullUrl);
      // Add to front
      recent.unshift(resource);
      // Limit to 3
      if (recent.length > 3) recent = recent.slice(0, 3);
      sessionStorage.setItem('recentResources', JSON.stringify(recent));
    } catch (e) {
      console.error('Error tracking resource access:', e);
    }
  };

  // Get faculty color and gradient by faculty name or code
  const getFacultyInfo = (facultyNameOrCode) => {
    if (!facultyNameOrCode) {
      // Return default UP blue if no faculty
      return {
        color: '#003366',
        gradient: 'linear-gradient(90deg, #003366 0%, #1a4d80 100%)',
        code: 'UP',
        name: 'University of Pretoria'
      };
    }

    const searchTerm = facultyNameOrCode.toLowerCase().trim();
    
    // Try to match by code first
    let faculty = faculties.find(f => f.code.toLowerCase() === searchTerm);
    
    // If no match, try to match by name (partial match)
    if (!faculty) {
      faculty = faculties.find(f => 
        f.name.toLowerCase().includes(searchTerm) || 
        searchTerm.includes(f.name.toLowerCase())
      );
    }
    
    // If still no match, return default
    if (!faculty) {
      return {
        color: '#003366',
        gradient: 'linear-gradient(90deg, #003366 0%, #1a4d80 100%)',
        code: 'UP',
        name: 'University of Pretoria'
      };
    }
    
    return faculty;
  };

  return {
    faculties,
    currentYear,
    getYearbookUrl,
    getYearbooks,
    sortYearbooksByUserFaculty,
    getStudentServices,
    getCampusLocations,
    getRecentResources,
    trackResourceAccess,
    getFacultyInfo
  };
}
